import React, {Fragment} from 'react';
import {format} from "date-fns";
import {formatTimeToNextStop} from "./utils/formatTimeToNextStop";

export default function PickUpData({shipment}) {

    let stack = [];

    if (shipment.ETAPickUp) {
        stack.push((<span>⇣ {format(shipment.ETAPickUp, "HH:mm")}</span>));
    }

    if (0 in shipment?.ShipmentRoute) {
        stack.push((<span>->{formatTimeToNextStop(shipment.ShipmentRoute[0].timeToNextStop)}</span>));
    }

    if (0 in shipment?.ShipmentRoute) {
        stack.push((<span>{shipment.ShipmentRoute[0].distanceToNextStop.toFixed(2)}km</span>));
    }

    return (
        <Fragment>
            {
                stack.map((info, index, array) => (
                    <Fragment key={index}>{info}
                        {(array.length -1 !== index && (
                            <Fragment>, </Fragment>
                        ))}
                    </Fragment>
                ))
            }
        </Fragment>
    );
};
